import { Descriptions } from 'antd';

import { GetPreviousPrintReportQuery } from 'generated/graphql';

import { useBuildExcavationAndBuildDescriptionItems } from './use-build-excavation-and-build-description-items';

interface ExcavationAndBuildInfoTableProps {
  previousReport: GetPreviousPrintReportQuery['shiftReport'][0] | undefined;
  averageExcavationPerRing: string | null;
  averageBuildPerRing: string | null;
}

export const ExcavationAndBuildInfoTable = ({
  previousReport,
  averageExcavationPerRing,
  averageBuildPerRing,
}: ExcavationAndBuildInfoTableProps) => {
  const items = useBuildExcavationAndBuildDescriptionItems({
    previousReport,
    averageExcavationPerRing,
    averageBuildPerRing,
  });

  return (
    <Descriptions
      items={items}
      column={{ xs: 1, sm: 6, md: 6, lg: 6, xl: 6, xxl: 6 }}
      className="header-info"
      bordered={false}
    />
  );
};
